import { useState } from "react";

import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

interface IAddNewListPopupControlProps {
    onCancel: () => void;
    onSave: (listName: string) => void;
    ContainerId: string;
}

function AddNewListPopupControl(props: IAddNewListPopupControlProps): JSX.Element {
    const { getText } = useTranslation();
    const [listName, setListName] = useState(null);

    function onTextChange(listName: string): void {
        setListName(listName);
    }

    function isDisabled(): boolean {
        return !listName;
    }

    return (
        <Modal
            showOverlay
            showX
            centerContent
            width={550}
            title={cacheStore.GetString("NewListLabel")}
            onClose={() => props.onCancel()}
            footer={(
                <div className="display-flex-justified-end">
                    <div className="margin-xs-left">
                        <button
                            className="btn btn-default"
                            data-cy="list-name-cancel"
                            data-action="cancel"
                            onClick={() => props.onCancel()}
                        >
                            {getText("CancelLabel")}
                        </button>
                    </div>
                    <div className="margin-xs-left">
                        <button
                            className="btn btn-primary"
                            data-cy="list-name-save"
                            disabled={isDisabled()}
                            onClick={() => props.onSave(listName)}
                        >
                            {getText("SaveLabel")}
                        </button>
                    </div>
                </div>
            )}
            disableOverlayClose
            draggable
        >
            <div className="p-body" data-cy="add-list-popup">
                <div className="row">
                    <div className="col-lg-12">
                        <label>{getText("PatientGroup_NewListNameLabel")}</label>
                    </div>
                    <div className="col-lg-12">
                        <input className="col-lg-12 form-control" type="text" id="add-list-name" onChange={(e: any) => onTextChange(e.target.value)} />
                    </div>
                </div>
            </div>
        </Modal>

    );
}

export { AddNewListPopupControl };
